"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePageViewReadyEventListener = exports.dispatchPageViewReadyEvent = exports.addPageViewReadyEventListener = void 0;
const PAGE_VIEW_READY_EVENT = 'pageViewReady';
const addPageViewReadyEventListener = (handleEvent) => {
    window.addEventListener(PAGE_VIEW_READY_EVENT, handleEvent);
};
exports.addPageViewReadyEventListener = addPageViewReadyEventListener;
const dispatchPageViewReadyEvent = () => {
    const event = new Event(PAGE_VIEW_READY_EVENT);
    window.dispatchEvent(event);
};
exports.dispatchPageViewReadyEvent = dispatchPageViewReadyEvent;
const removePageViewReadyEventListener = (handleEvent) => {
    window.removeEventListener(PAGE_VIEW_READY_EVENT, handleEvent);
};
exports.removePageViewReadyEventListener = removePageViewReadyEventListener;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZVZpZXdMaXN0ZW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy93aW5kb3dMaXN0ZW5lci9wYWdlVmlld0xpc3RlbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0scUJBQXFCLEdBQUcsZUFBZSxDQUFDO0FBRTlDLE1BQU0sNkJBQTZCLEdBQUcsQ0FBQyxXQUF1QixFQUFRLEVBQUU7SUFDcEUsTUFBTSxDQUFDLGdCQUFnQixDQUFDLHFCQUFxQixFQUFFLFdBQVcsQ0FBQyxDQUFDO0FBQ2hFLENBQUMsQ0FBQztBQVlFLHNFQUE2QjtBQVZqQyxNQUFNLDBCQUEwQixHQUFHLEdBQVMsRUFBRTtJQUMxQyxNQUFNLEtBQUssR0FBRyxJQUFJLEtBQUssQ0FBQyxxQkFBcUIsQ0FBQyxDQUFDO0lBQy9DLE1BQU0sQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLENBQUM7QUFDaEMsQ0FBQyxDQUFDO0FBUUUsZ0VBQTBCO0FBTjlCLE1BQU0sZ0NBQWdDLEdBQUcsQ0FBQyxXQUF1QixFQUFRLEVBQUU7SUFDdkUsTUFBTSxDQUFDLG1CQUFtQixDQUFDLHFCQUFxQixFQUFFLFdBQVcsQ0FBQyxDQUFDO0FBQ25FLENBQUMsQ0FBQztBQUtFLDRFQUFnQyJ9


// WEBPACK FOOTER //
// ../../../../src/utils/windowListener/pageViewListener.ts